import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {TopPerformersWidgetController} from "../top-performers-widget.controller";

export class TopPerformersWidgetProps extends BaseModuleProps {
  controller: TopPerformersWidgetController;
}
